import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'workers_do_not_have_unrestricted_access_verify_accuracy'

export const dataPointDefinition = {
  retracedId: 'workers_do_not_have_unrestricted_access_verify_accuracy',
  name: 'Workers do not have unrestricted access to verify the accuracy of working hours',
  description: 'Unrestricted access means workers can access attendance and payroll records at any time upon request. ',
  meta: {
    slcpMeta: {
      key: 'wh-wor-27x',
      number: 'WH-WOR-4-6',
      masterType: 'Question',
      versionImported: '1.7.0',
    },
  },
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'wh-wor-27x', version: '1.7.0', provider: 'slcp'}],
  sortingId: 36560,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
